export const environment = {
  assetsUrl: 'https://tu360-dev.apps.ambientesbc.com/mega-menu/assets',
  urlPortal: 'bancolombia-qa.apps.ambientesbc.com/personas',
  urlTu360: 'bancolombia-qa.apps.ambientesbc.com/tu360',
  contenful: ''
};